exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-kalkulator-psi-jsx": () => import("./../../../src/pages/kalkulator-psi.jsx" /* webpackChunkName: "component---src-pages-kalkulator-psi-jsx" */)
}

